import { forwardRef, type Ref, type SVGProps } from "react";
const IconQuestionMarkCircleFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m-.426 21.25a1.355 1.355 0 1 1 1.256-1.35 1.3 1.3 0 0 1-1.256 1.35m2.9-7.351c-1.446.879-1.737 1.392-1.875 2.285-.191.846-.68.937-1.032.937a1.092 1.092 0 0 1-1.124-1.221v-.147a2.87 2.87 0 0 1 1.684-2.569c1.355-.847 1.792-1.456 1.792-2.506a1.95 1.95 0 0 0-2.09-1.986 2.144 2.144 0 0 0-2.167 1.57 1.09 1.09 0 0 1-1.107.83.973.973 0 0 1-1.055-1.065 2.5 2.5 0 0 1 .284-1.158C12.4 9.55 13.963 8.75 15.969 8.75c2.71 0 4.531 1.54 4.531 3.832a3.65 3.65 0 0 1-2.024 3.318z"
      className="help-circle"
    />
    <path
      fill="#fff"
      d="M15.969 8.75c-2.006 0-3.574.8-4.185 2.119a2.5 2.5 0 0 0-.284 1.158.973.973 0 0 0 1.055 1.064 1.09 1.09 0 0 0 1.107-.83 2.144 2.144 0 0 1 2.167-1.57 1.95 1.95 0 0 1 2.09 1.986c0 1.05-.437 1.659-1.792 2.506a2.87 2.87 0 0 0-1.684 2.569v.148a1.092 1.092 0 0 0 1.126 1.222c.352 0 .841-.091 1.032-.937.138-.893.429-1.406 1.875-2.285a3.65 3.65 0 0 0 2.024-3.318c0-2.292-1.821-3.832-4.531-3.832m-.395 11.797A1.355 1.355 0 1 0 16.83 21.9a1.3 1.3 0 0 0-1.256-1.353"
      className="help-question-mark"
    />
  </svg>
);
const ForwardRef = forwardRef(IconQuestionMarkCircleFilledSVG);
ForwardRef.displayName = "IconQuestionMarkCircleFilled";
export { ForwardRef as IconQuestionMarkCircleFilled };
